import { inject } from "mobx-react";
import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core";
import Table from "../../../components/Table/Table";
import string from "../../../utils/string";
import { applyCurrencyMask } from "../../../utils/CurrencyMask";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { COLUMNS } from "../../Atendimento/Tabs/Odontograma/Modal/Orcamento/Constatnts";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";

const Procedimentos = observer(({ classes, orcamentoStore }) => {
  const { orcamento, errors } = orcamentoStore;
  const { orcamentoProcedimentos, tipoPagamento, convenio } = orcamento;

  useEffect(() => {
    somarValores();
  }, [orcamentoProcedimentos]);

  useEffect(() => {
    alteraValorProcedimentoPorConvenio();
  }, [convenio]);

  const alteraValorProcedimentoPorConvenio = () => {
    const valoresProcedimentoPorConvenio = orcamentoProcedimentos.map(
      (item) => {
        const valorUnitarioConvenio = orcamento?.id
          ? item.valorUnitario
          : item.procedimento?.convenioProcedimentos?.find(
              (convenioProcedimento) =>
                convenioProcedimento?.convenio?.id === convenio?.value
            )?.valor || 0;

        return { ...item, valorUnitario: valorUnitarioConvenio };
      }
    );

    orcamentoStore.orcamento.orcamentoProcedimentos = valoresProcedimentoPorConvenio;
  };

  const allCheckBoxChecked = () => {
    const allChecked =
      orcamentoProcedimentos &&
      orcamentoProcedimentos.every((item) => item.checked);
    return allChecked;
  };

  const handleCheckAll = () => {
    const checked = allCheckBoxChecked();
    const procedimentosSelecionados = orcamentoProcedimentos.map((item) => {
      return {
        ...item,
        checked: !checked,
      };
    });

    orcamentoStore.orcamento.orcamentoProcedimentos = procedimentosSelecionados;
  };

  const handleChangeCheck = (row, index) => {
    const list = [...orcamentoProcedimentos];
    list[index].checked = !list[index].checked;
    orcamentoStore.orcamento.orcamentoProcedimentos = list;
  };

  const handleValor = (value, row) => {
    const procedimentos = orcamentoProcedimentos;

    const index = procedimentos.findIndex((item) => item.id === row.id);
    procedimentos[index] = {
      ...procedimentos[index],
      valorUnitario: value,
    };

    somarValores();
  };

  const somarValores = () => {
    const soma = orcamentoProcedimentos
      .filter((item) => item.checked)
      .reduce((accumulator, currentValue) => {
        const valor =
          typeof currentValue.valorUnitario === "string"
            ? string.currencyMaskToFloat(currentValue.valorUnitario)
            : currentValue?.valorUnitario;

        return accumulator + valor;
      }, 0);

    orcamentoStore.orcamento.valor = soma;
  };

  const handleStatus = (status, procedimento) => {
    const orcamentoProcedimentosStatus = orcamentoProcedimentos.map((item) => {
      return {
        ...item,
        status: procedimento.id === item.id ? status : item.status,
      };
    });

    orcamentoStore.handleFieldModal(
      "orcamentoProcedimentos",
      orcamentoProcedimentosStatus
    );
  };

  const isOpenInfosOrcamento = orcamentoStore.openInfosOrcamento
  return (
    <div className={classes.container}>
      <div
        className={classNames(
          classes.content,
          errors.procedimentos && classes.contentError
        )}
      >
        <Table
          dados={orcamentoProcedimentos || []}
          columns={COLUMNS({
            handleCheckAll,
            allCheckBoxChecked,
            handleChangeCheck,
            handleValor,
            errors,
            handleStatus,
            orcamento,
            isGerenciadorOrcamento: true,
          })}
          classes={{
            tabela: classNames(
              !isOpenInfosOrcamento? classes.tableMaior:
              classes.table,
              (tipoPagamento.value === "A_PRAZO" && isOpenInfosOrcamento) && classes.tableMenor
            ),
          }}
          emptyMessage={<MensagemListaVazia />}
        />
        <div className={classes.containerTotal}>
          <div className={classes.contentTotal}>
            <label className={classes.total}> Subtotal: </label>
            <label className={classes.totalValue}>
              {applyCurrencyMask(orcamento.valor)}
            </label>
          </div>
          <div className={classes.contentTotal}>
            <label className={classes.total}> Total: </label>
            <label className={classes.totalValue}>
              {typeof orcamento.subtotal === "string"
                ? orcamento.subtotal
                : applyCurrencyMask(orcamento.subtotal)}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
});

const styles = {
  container: {
    height: "100%",
  },
  content: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.10)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent:"space-between",
  

    "& thead": {
      "& tr": {
        height: "40px",
        borderRadius: "10px 0 0 10px",
      },

      "& th": {
        textAlign: "left",
        top: 0,
        position: "sticky",
        padding: "0 0 0 10px",

        "&:first-child": {
          width: "29px",
          borderRadius: "10px 0 0 0",
        },

        "&:last-child": {
          borderRadius: "0 10px 0 0",
          width: "100px",
        },
      },
    },

    "& tbody": {
      "& tr": {
        "& td": {
          padding: "0 0 0 10px",
          border: "none",
        },
      },
    },
    "& #inputValor": {
      background: "#F2F2F2",
      borderRadius: "8px",
      height: "30px",
      maxWidth:"120px",
      paddingLeft: "8px",
    },
  },
  contentError: {
    border: "1px solid #FB7676",
  },
  wrapperLoading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  table: {
    height: "100%",
    overflow: "auto",
    maxHeight: "173px",
  },
  tableMaior:{
     height: "100%",
    overflow: "auto",
    maxHeight: "300px",
  },
  tableSelectProcedimento: {
    maxHeight: "120px",
  },
  tableSemValor: {
    maxHeight: "226px",
  },
  tableMenor: {
    maxHeight: "140px",
  },
  containerTotal: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: "10px",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  },
  contentTotal: {
    height: "40px",
    paddingRight: "8px",
    textAlign: "end",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  total: {
    fontWeight: 600,
    fontSize: 16,
  },
  totalValue: {
    fontWeight: 600,
    fontSize: 18,
  },
  reactSelect: {
    width: "100%",
  },
  rowSelectProcedimento: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    marginBottom: "4px",
  },
  contentSelectProcedimento: {
    height: "calc(100% - 50px)",
  },
};

const ProcedimentosWithStyles = withStyles(styles)(Procedimentos);
export default withRouter(inject("orcamentoStore")(ProcedimentosWithStyles));
